// 课程中心-资源管理
export const courseTypeData = [
  {
    value: 1,
    label: '素质课程',
    children: [
      {
        value: 11,
        label: '艺术',
        children: [],
        loading: false
      },
      {
        value: 12,
        label: '科技',
        children: [],
        loading: false
      },
      {
        value: 13,
        label: '体育',
        children: [],
        loading: false
      },
      {
        value: 14,
        label: '美术',
        children: [],
        loading: false
      },
      {
        value: 15,
        label: '综合实践',
        children: [],
        loading: false
      }
    ],
    loading: false
  },
  {
    value: 2,
    label: '托管',
    children: [
      {
        value: 21,
        label: '早托',
        children: [],
        loading: false
      },
      {
        value: 22,
        label: '午托',
        children: [],
        loading: false
      },
      {
        value: 23,
        label: '晚托',
        children: [],
        loading: false
      },
      {
        value: 24,
        label: '全托',
        children: [],
        loading: false
      }
    ],
    loading: false
  }
]
// 推荐年级
export const likeGradesList = [
  {
    id: 13,
    name: '小班'
  },
  {
    id: 14,
    name: '中班'
  },
  {
    id: 15,
    name: '大班'
  },
  {
    id: 1,
    name: '一年级'
  },
  {
    id: 2,
    name: '二年级'
  },
  {
    id: 3,
    name: '三年级'
  },
  {
    id: 4,
    name: '四年级'
  },
  {
    id: 5,
    name: '五年级'
  },
  {
    id: 6,
    name: '六年级'
  },
  {
    id: 7,
    name: '初一'
  },
  {
    id: 8,
    name: '初二'
  },
  {
    id: 9,
    name: '初三'
  },
  {
    id: 10,
    name: '高一'
  },
  {
    id: 11,
    name: '高二'
  },
  {
    id: 12,
    name: '高三'
  }
]
// 课程级别
export const courseLevelList = [
  { label: '基础班', value: 1 },
  { label: '提高班', value: 2 },
  { label: '精英班', value: 3 },
  { label: '其他', value: 4 }
]
